import { render, staticRenderFns } from "./AppointmentCategoryDropdown.vue?vue&type=template&id=7a830bf2&scoped=true&"
import script from "./AppointmentCategoryDropdown.vue?vue&type=script&lang=js&"
export * from "./AppointmentCategoryDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a830bf2",
  null
  
)

export default component.exports